import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button, Grid, type GridProps } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { type ClassesType, Text } from '@pbt/pbt-ui-components'

const useStyles = makeStyles(
  (theme) => ({
    button: {},
    container: {
      [theme.breakpoints.down('md')]: {
        borderBottom: theme.constants.filterBorder,
      },
    },
    text: {
      textTransform: 'none',
      [theme.breakpoints.up('md')]: {
        fontWeight: 'bold',
      },
    },
    thinText: {
      fontWeight: 400,
      textDecoration: 'underline',
    },
    thinArrow: {
      width: '0.65em',
      height: '0.65em',
      marginRight: theme.spacing(0.5),
    },
    arrowIcon: {},
  }),
  { name: 'DetailsBackButton' },
)

export interface DetailsBackButtonProps {
  children: React.ReactNode
  className?: string
  classes?: ClassesType<typeof useStyles>
  fullWidth?: boolean
  lg?: GridProps['lg']
  md?: GridProps['md']
  onClick: () => void
  showIcon?: boolean
  sm?: GridProps['sm']
  thin?: boolean
}

const DetailsBackButton = ({
  classes: classesProp,
  className,
  onClick,
  children,
  fullWidth,
  lg = !fullWidth && 3,
  md = !fullWidth && 5,
  sm = !fullWidth && 12,
  showIcon = true,
  thin = false,
}: DetailsBackButtonProps) => {
  const classes = useStyles({ classes: classesProp })
  return (
    <Grid
      container
      item
      className={classNames(className, classes.container)}
      lg={lg}
      md={md}
      sm={sm}
    >
      <Button className={classes.button} onClick={onClick}>
        {showIcon && (
          <ArrowBackIcon
            className={classNames(classes.arrowIcon, {
              [classes.thinArrow]: thin,
            })}
          />
        )}
        <Text
          strong
          className={classNames(classes.text, { [classes.thinText]: thin })}
          variant="body2"
        >
          {children}
        </Text>
      </Button>
    </Grid>
  )
}

export default DetailsBackButton
